module.exports = __webpack_public_path__ + "media/images/favicon/favicon-180-f1915887f4080d2546c1ba0fb6b78d93.png";